import { installEarlyErrorReporting, startMonitoring } from "./lib/monitoring";

installEarlyErrorReporting();
void startMonitoring();
